import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlined from "@material-ui/icons/LockOutlined";
import PropTypes from "prop-types";
import queryString from "query-string";
import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { values } from "lodash";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import { resetPassword } from "reducers/user/actions";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

const styles = theme => ({
  ...loginPageStyle(theme),
  container: {
    ...loginPageStyle(theme).container,
    paddingTop: "18vh",
  },
  loginButtonWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: theme.spacing.unit,
    position: 'relative',
  },
  titleActions: {
    color: "white",
    display: "flex",
    justifyContent: "center",
  },
});

class ResetPasswordPage extends Component {
  state = {
    confirmacaoSenha: "",
    loading: false,
    senha: "",
    updatingPasswordMsg: "",
  };

  handleClick = () => {
    const { history, location, resetPassword } = this.props;
    const { confirmacaoSenha, senha } = this.state;
    const { codigo, id } = queryString.parse(location.search);

    if (confirmacaoSenha !== senha) {
      return this.setState({ updatingPasswordMsg: "As senhas devem ser iguais." });
    }

    this.setState({ loading: true, updatingPasswordMsg: "" });

    resetPassword({ codigo, confirmacaoSenha, id, senha })
      .then(() => history.push("/dashboard"))
      .catch(({ response }) => {
        this.setState({ loading: false, updatingPasswordMsg: values(response.data).join(" ") });
      });
  }

  render() {
    const { classes } = this.props;
    const { confirmacaoSenha, loading, senha, updatingPasswordMsg } = this.state;

    return (
      <div className={classes.container}>
        <GridContainer alignContent="center" justify="center">
          <GridItem md={4} sm={6} xs={12}>
            <form>
              <ECCard
                content={
                  <div>
                    <div>
                      <CustomInput
                        error={updatingPasswordMsg}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          disabled: loading,
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutlined className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: evt => this.setState({ senha: evt.target.value }),
                          type: "password",
                        }}
                        labelText="Nova senha"
                      />
                      <CustomInput
                        error={updatingPasswordMsg}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          disabled: loading,
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutlined className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: evt => this.setState({ confirmacaoSenha: evt.target.value }),
                          type: "password",
                        }}
                        labelText="Confirmação de senha"
                      />
                    </div>
                    <div className={classes.loginButtonWrapper}>
                      {loading ? <BouncingLoader /> : (
                        <Button
                          color="rose"
                          disabled={!senha || !confirmacaoSenha}
                          onClick={this.handleClick}
                          size="lg"
                        >
                          Resetar
                        </Button>
                      )}
                    </div>
                  </div>
                }
                hasIcon={false}
                title="Resetar Senha"
                titleActionsClass={classes.titleActions}
              />
            </form>
            {updatingPasswordMsg && (
              <SnackbarContent color="rose" message={updatingPasswordMsg} />
            )}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ResetPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  resetPassword,
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(ResetPasswordPage));



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPasswordPage.jsx